import { useRef as r, useReducer as n, useEffect as e, useLayoutEffect as u } from "react";
import { makeSubject as t, subscribe as c } from "wonka";
import { unstable_scheduleCallback as o, unstable_getCurrentPriorityLevel as a, unstable_cancelCallback as l } from "scheduler";

var s = "undefined" == typeof window,
    i = s ? e : u,
    f = function f(r, n, e) {
  return d(r, n, e)[0];
},
    d = function d(u, f, _d) {
  var w = r({
    subject: t(),
    value: _d,
    onValue: function onValue(r) {
      w.current.value = r;
    },
    teardown: null,
    task: null
  }),
      b = n(function (r, n) {
    return w.current.value = n, r + 1;
  }, 0)[1];

  if (null === w.current.teardown) {
    var v = c(function (r) {
      return w.current.onValue(r);
    })(u(w.current.subject.source)).unsubscribe;
    w.current.subject.next(f), s ? v() : (w.current.teardown = v, w.current.task = o(a(), w.current.teardown));
  }

  function j() {
    null !== w.current.teardown && w.current.teardown();
  }

  return i(function () {
    return null !== w.current.task && l(w.current.task), j;
  }, []), e(function () {
    var r = w.current.onValue !== b;
    w.current.onValue = b, null === w.current.teardown && (w.current.teardown = c(b)(u(w.current.subject.source)).unsubscribe), r || w.current.subject.next(f);
  }, [f]), [w.current.value, w.current.subject.next];
};

export { d as useOperator, f as useOperatorValue };